import { Typography } from '@mui/material';
import React from 'react';
import { ReactElement } from 'react';
import { NameDataPair } from '../../Extensions/Extensions';

type FormDataReviewProps = {
    displayText: NameDataPair[];
};

export default function FormDataReview({ displayText }: FormDataReviewProps): ReactElement {
    return (
        <>
            {displayText.map((dt) => {
                return (
                    <Typography key={dt.name} component="p">
                        {dt.name + ' ' + dt.data}
                    </Typography>
                );
            })}
        </>
    );
}
